import { app } from '../../bootstrap/core';
import { loginByTokenState } from './loginByToken.state';
import { loginByTokenComponent } from './loginByToken.component';

app.config(loginByTokenState);
app.component(loginByTokenComponent.name, loginByTokenComponent);
